import Checkbox, { type Props as CheckboxProps } from '@components/Checkbox';
import colors from '@constants/colors';
import ArrowLineRight from '@icons/arrow/ArrowLineRight';

import styles from './styles.module.scss';

interface Props extends CheckboxProps {
    onClick?: () => void;
    required?: boolean;
}

function CheckboxLI(props: Props) {
  const {
    isChecked, toggleCheckbox, children, onClick, required,
  } = props;
  return (
        <div className={styles.container} aria-label='check-box-list-item'
                   onClick={onClick}>
            <div className={styles.checkbox}>
                <Checkbox isChecked={isChecked}
                          toggleCheckbox={toggleCheckbox}>
                    {children}
                    {required && <span className={styles.required}>*</span>}
                </Checkbox>
            </div>
            <ArrowLineRight color={colors.gray5}/>
        </div>
  );
}

export default CheckboxLI;
